import React from 'react';

class Title extends React.Component {
    render() {
        return (
            <section className="dialer">
                <h1 className="dialer__title">Dialer EXpress</h1>
                <img className="dialer__img" src="images/operators.png" alt="" role="presentation"/>
                <p className="dialer__subtitle">Система исходящего обзвона респондентов с поддержкой предиктивного и
                прогрессивного режима набора номеров.</p>
                <div className="dialer__begin">
                    <p className="dialer__begin-text">Начиная работать на проектах с
                    исходящими вызовами контакт-центры часто сталкиваются с рядом трудностей. Операторы долго набирают
                    номера респондентов, не могут до них дозвониться, а дозваниваясь, вдруг выясняют, что ошиблись с
                    номером. А записи? Их поиск, попытка как-то связать хоть с какой-нибудь анкетой? Отсутствие
                    статистики и промежуточных отчётов превращает работу в практически неуправляемый процесс.</p>
                    <p className="dialer__begin-text">Так, в душе некоторых руководителей появляется мечта заменить всех
                    своих сотрудников бездушными, но исполнительными роботами.</p>
                    <p className="dialer__begin-text">Ну,
                    не всех, но хотя бы половину. Мы работаем над этим. И, возможно, даже сможем Вам немного помочь.</p>
                    <p className="dialer__begin-text">Если Вы и так всё знаете и уже хотите скорее приобрести
                        полноценное решение всех Ваших проблем: переходите сразу к <a className="dialer__begin-link"
                                                                                      href="#price">стоимости</a>.</p>
                    <div className="dialer__item">
                        <div className="dialer__author-img"><img src="images/MaksimA.png"/></div>
                        <div className="dialer__author-info"><p className="dialer__author-job">Генеральный директор ООО
                            «Системы информации и связи»</p><p className="dialer__author-name">Акульшин Максим
                            Владимирович</p></div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Title;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/Title.js